import { Component } from "@angular/core";

@Component({
  selector: "poa-european-international",
  templateUrl: "./PoA-european-international.component.html",
  styleUrls: ["../poa-base.component.scss"],
  standalone: true,
})
export class PoAEuropeanInternationalComponent {}
